<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import ProductionOrderForm from "./components/ProductionOrderForm.vue"

defineProps<{
  production_order: {
    id: number
    company_id: number | ""
    expected_at: string
    items: Array<{
      id?: number | null
      product_id: number | ""
      quantity: string
    }>
  }
  products: Array<{ label: string; value: number }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <ProductionOrderForm
      mode="edit"
      title="Editar ordem de producao"
      subtitle="Atualize os itens pendentes antes de iniciar a producao."
      :production-order="production_order"
      :products="products"
      :errors="errors"
    />
  </AppShell>
</template>

